module.exports = __webpack_public_path__ + "img/kuaishou5s.18c8ae94.png";